/* WLC plate search results (section "WLC Plate Results").
   Asks the FPDSM search service for plates and shows them. All text from the
   service is inserted with textContent, never as HTML. Prices come from the
   server and already include VAT. */
(function () {
  'use strict';

  var TIMEOUT_MS = 15000;

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function gbp(n) { return '£' + Number(n).toLocaleString('en-GB'); }
  function clean(q) { return String(q || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 10); }
  function whole(v) { v = String(v || '').replace(/[£,\s]/g, ''); return /^\d{1,7}$/.test(v) ? v : ''; }

  function getJSON(url) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, TIMEOUT_MS) : null;
    return fetch(url, { mode: 'cors', credentials: 'omit', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (body) {
          return { status: r.status, body: body };
        });
      }, function () { return { status: 0, body: {} }; })
      .then(function (res) { if (timer) clearTimeout(timer); return res; });
  }

  function init(root) {
    if (root.getAttribute('data-wlc-ready')) return;
    root.setAttribute('data-wlc-ready', '1');

    var api = (root.getAttribute('data-api') || '').replace(/\/+$/, '');
    var email = root.getAttribute('data-email') || '';
    var subject = root.getAttribute('data-subject') || 'Enquiry for registration';
    var phone = root.getAttribute('data-phone') || '';
    var tel = root.getAttribute('data-tel') || '';
    var buyUrl = (root.getAttribute('data-buy') || '').replace(/\/+$/, '');
    var buyOn = false;                 // the search service says whether BUY NOW is switched on
    var form = root.querySelector('[data-wlc-form]');
    var title = root.querySelector('[data-wlc-title]');
    var status = root.querySelector('[data-wlc-status]');
    var out = root.querySelector('[data-wlc-output]');
    var qIn = form.querySelector('input[name="q"]');
    var minIn = form.querySelector('input[name="min"]');
    var maxIn = form.querySelector('input[name="max"]');
    var msg = form.querySelector('.wlc-ps__form-msg');

    var params = new URLSearchParams(window.location.search);
    var q = clean(params.get('q'));
    var pmin = whole(params.get('min'));
    var pmax = whole(params.get('max'));
    var advKey = String(params.get('adv') || '').toLowerCase();
    if (!/^(new|prefix|ni)$/.test(advKey)) advKey = '';
    if (advKey) q = '';                       // an advanced search wins over ?q=
    var label = q;                            // how the search reads in headings
    qIn.value = q;
    if (!advKey) { minIn.value = pmin; maxIn.value = pmax; }

    setupAdvanced();

    form.addEventListener('submit', function (e) {
      var c = clean(qIn.value);
      if (c.length < 3) {
        e.preventDefault();
        msg.textContent = 'Please enter at least 3 letters or numbers.';
        qIn.focus();
        return;
      }
      msg.textContent = '';
      qIn.value = c;
      minIn.value = whole(minIn.value);
      maxIn.value = whole(maxIn.value);
      // Leave empty price boxes out of the address.
      [minIn, maxIn].forEach(function (i) { i.disabled = !i.value; });
    });

    // Coming back with the browser's Back button: re-enable the price boxes.
    window.addEventListener('pageshow', function () { minIn.disabled = false; maxIn.disabled = false; });

    // ---------------------------------------------------------------- Advanced search
    // Three tabs (New / Prefix / NI). Letters match from the start, the number exactly;
    // blank = any. The search goes in the address (?adv=new&a=AB&n=12&l=C), so Back and
    // shared links work.
    function setupAdvanced() {
      var toggle = root.querySelector('[data-wlc-adv-toggle]');
      var panel = root.querySelector('[data-wlc-adv]');
      if (!toggle || !panel) return;
      var tabs = Array.prototype.slice.call(panel.querySelectorAll('[role="tab"]'));
      var panes = Array.prototype.slice.call(panel.querySelectorAll('[data-panel]'));
      var aform = panel.querySelector('[data-wlc-adv-form]');
      var amsg = aform.querySelector('.wlc-ps__form-msg');
      var go = aform.querySelector('.wlc-ps__adv-go');
      var amin = aform.querySelector('[data-f="min"]');
      var amax = aform.querySelector('[data-f="max"]');
      var ageSel = panel.querySelector('[data-panel="new"] [data-f="n"]');
      var current = advKey || 'new';
      var agesAsked = false;

      function pane(key) { return panel.querySelector('[data-panel="' + key + '"]'); }
      function field(key, f) { return pane(key).querySelector('[data-f="' + f + '"]'); }

      function select(key, focus) {
        current = key;
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-tab') === key;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on && focus) t.focus();
        });
        panes.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== key; });
        amsg.textContent = '';
      }

      function loadAges() {
        if (agesAsked) return;
        agesAsked = true;
        var want = advKey === 'new' ? String(params.get('n') || '') : '';
        getJSON(api + '/v1/advanced/ages').then(function (res) {
          if (res.status === 200 && res.body.ages) {
            res.body.ages.forEach(function (a) {
              var o = document.createElement('option');
              o.value = a; o.textContent = a;
              ageSel.appendChild(o);
            });
            if (want) ageSel.value = want.length === 1 ? '0' + want : want;
          } else {
            go.disabled = true;
            amsg.textContent = res.status === 503 && res.body.error === 'preparing'
              ? 'Advanced search is being prepared. Please try again later.'
              : 'Advanced search is unavailable right now. Please try again in a few minutes.';
          }
        });
      }

      function open(show) {
        panel.hidden = !show;
        toggle.setAttribute('aria-expanded', show ? 'true' : 'false');
        toggle.classList.toggle('is-open', show);
        if (show) loadAges();
      }

      toggle.addEventListener('click', function () { open(panel.hidden); });
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t.getAttribute('data-tab'), false); });
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          select(tabs[(i + d + tabs.length) % tabs.length].getAttribute('data-tab'), true);
        });
      });

      aform.addEventListener('submit', function (e) {
        e.preventDefault();
        var p = pane(current);
        function val(f) {
          var i = p.querySelector('[data-f="' + f + '"]');
          return i ? String(i.value || '').toUpperCase().replace(/\s+/g, '') : '';
        }
        var a = val('a'), n = val('n'), l = val('l');
        if (!a && !n && !l) { amsg.textContent = 'Fill in at least one box.'; return; }
        if (!/^[A-Z]*$/.test(a) || !/^[A-Z]*$/.test(l)) { amsg.textContent = 'Use letters only in the letter boxes.'; return; }
        if (n && current !== 'new' && !(/^\d{1,3}$/.test(n) && +n >= 1)) {
          amsg.textContent = 'The number must be between 1 and 999.'; return;
        }
        var out = new URLSearchParams({ adv: current });
        if (a) out.set('a', a);
        if (n) out.set('n', current === 'new' ? n : String(+n));
        if (l) out.set('l', l);
        var lo = whole(amin.value), hi = whole(amax.value);
        if (lo) out.set('min', lo);
        if (hi) out.set('max', hi);
        window.location.href = window.location.pathname + '?' + out.toString();
      });

      // Coming from an advanced search (or the home page link): open it, filled in.
      if (advKey) {
        select(advKey, false);
        ['a', 'n', 'l'].forEach(function (f) {
          var i = field(advKey, f);
          var v = String(params.get(f) || '').toUpperCase();
          if (i && v && !(advKey === 'new' && f === 'n')) i.value = v;
        });
        amin.value = pmin;
        amax.value = pmax;
      }
      if (advKey || params.get('advanced')) open(true);
    }

    if (!q && !advKey) return;
    var path, base;
    if (advKey) {
      path = '/v1/advanced';
      base = { section: advKey };
      ['a', 'n', 'l'].forEach(function (f) { var v = params.get(f); if (v) base[f] = v; });
    } else {
      title.textContent = 'Results for “' + q + '”';
      document.title = 'Results for ' + q + ' – ' + document.title;
      if (q.length < 3) { status.textContent = 'Please enter at least 3 letters or numbers.'; return; }
      path = '/v1/search';
      base = { q: q };
    }

    function query(extra) {
      var p = new URLSearchParams(base);
      if (pmin) p.set('min', pmin);
      if (pmax) p.set('max', pmax);
      Object.keys(extra || {}).forEach(function (k) { p.set(k, extra[k]); });
      return api + path + '?' + p.toString();
    }

    function unavailable() {
      out.textContent = '';
      var box = el('div', 'wlc-ps__down');
      box.setAttribute('role', 'status');
      var ns = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('width', '44'); svg.setAttribute('height', '44'); svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none'); svg.setAttribute('stroke', '#db0000'); svg.setAttribute('stroke-width', '2');
      svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('aria-hidden', 'true');
      [['circle', { cx: 12, cy: 12, r: 10 }], ['path', { d: 'M12 7v6' }], ['path', { d: 'M12 16.5v.5' }]]
        .forEach(function (s) {
          var n = document.createElementNS(ns, s[0]);
          Object.keys(s[1]).forEach(function (k) { n.setAttribute(k, s[1][k]); });
          svg.appendChild(n);
        });
      box.appendChild(svg);
      var text = el('div');
      text.appendChild(el('h2', null, 'Plate search is temporarily unavailable'));
      text.appendChild(el('p', null, 'Please try again in a few minutes, or call us and we’ll check availability for you.'));
      box.appendChild(text);
      if (tel) {
        var call = el('a', 'wlc-ps__call', 'Call Us : ' + phone);
        call.href = 'tel:' + tel;
        box.appendChild(call);
      }
      out.appendChild(box);
    }

    function message(text) {
      out.textContent = '';
      out.appendChild(el('p', 'wlc-ps__message', text));
    }

    function row(item) {
      var li = el('li', 'wlc-ps__row');
      var plate = el('div', 'wlc-ps__plate', item.plate);
      plate.setAttribute('role', 'img');
      plate.setAttribute('aria-label', 'Number plate ' + item.plate);
      li.appendChild(plate);
      var price = el('div', 'wlc-ps__price');
      price.appendChild(el('span', 'wlc-ps__amount', gbp(item.price)));
      price.appendChild(el('span', 'wlc-ps__vat', 'inc. VAT'));
      if (item.price_drop) price.appendChild(el('span', 'wlc-ps__drop', 'Price drop'));
      li.appendChild(price);
      var actions = el('div', 'wlc-ps__actions');
      if (email) {
        var a = el('a', 'wlc-ps__btn', 'Enquire');
        a.href = 'mailto:' + email + '?subject=' + encodeURIComponent(subject + ' ' + item.plate);
        a.setAttribute('aria-label', 'Enquire about ' + item.plate);
        actions.appendChild(a);
      }
      if (buyOn && buyUrl) {
        var b = el('button', 'wlc-ps__btn wlc-ps__btn--buy', 'Buy now');
        b.type = 'button';
        b.setAttribute('aria-label', 'Buy ' + item.plate + ' now');
        b.addEventListener('click', function () { buyNow(item.plate, b, li); });
        actions.appendChild(b);
      }
      li.appendChild(actions);
      return li;
    }

    function rowMessage(li, text) {
      var m = li.querySelector('.wlc-ps__row-msg');
      if (!m) { m = el('p', 'wlc-ps__row-msg'); m.setAttribute('role', 'alert'); li.appendChild(m); }
      m.textContent = text;
    }

    // BUY NOW: the server makes (or reuses) the Shopify product and sets its price;
    // here we only put it in the basket and go to the cart.
    // While waiting: "Adding to cart – please wait… 5", counting down, then "Almost done…".
    function startWaiting(btn) {
      var left = 5;
      btn.disabled = true;
      btn.classList.add('is-busy');
      function show() {
        btn.textContent = left > 0 ? 'Adding to cart \u2013 please wait\u2026 ' + left : 'Almost done\u2026';
      }
      show();
      var t = setInterval(function () { left -= 1; show(); if (left <= 0) clearInterval(t); }, 1000);
      return function stop() {
        clearInterval(t);
        btn.disabled = false;
        btn.classList.remove('is-busy');
        btn.textContent = 'Buy now';
      };
    }

    function buyNow(plate, btn, li) {
      var stopWaiting = startWaiting(btn);
      rowMessage(li, '');
      fetch(buyUrl + '/v1/buy', {
        method: 'POST', mode: 'cors', credentials: 'omit',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ plate: plate })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (b) { return { status: r.status, body: b }; });
      }, function () { return { status: 0, body: {} }; }).then(function (res) {
        if (res.status !== 200 || !res.body.variant_id) {
          throw new Error(res.body.message || 'Sorry, we couldn\u2019t add this plate to your basket. Please try again or click Enquire.');
        }
        return addPlateAndFee(res.body.variant_id, res.body.fee_variant_id);
      }).then(function () {
        window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
      }).catch(function (err) {
        stopWaiting();
        rowMessage(li, err.message);
      });
    }

    // The plate and its £80 Registration/Transfer Fee go into the cart together. If the
    // plate is already in the cart (stock is 1), just open the cart; the cart page keeps
    // the number of fees equal to the number of plates (snippets/wlc-fee-sync.liquid).
    function addPlateAndFee(plateId, feeId) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); }, function () { return { items: [] }; })
        .then(function (cart) {
          var inCart = (cart.items || []).some(function (it) { return it.variant_id === plateId; });
          if (inCart) return true;
          var items = [{ id: plateId, quantity: 1 }];
          if (feeId) items.push({ id: feeId, quantity: 1 });
          return addToCart(items, 6);
        });
    }

    // A brand-new product can take a moment to reach the shop front, so retry briefly.
    function addToCart(items, tries) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (r.ok) return true;
        if (tries > 1 && (r.status === 404 || r.status === 422)) {
          return new Promise(function (ok) { setTimeout(ok, 1500); })
            .then(function () { return addToCart(items, tries - 1); });
        }
        return r.json().catch(function () { return {}; }).then(function (b) {
          throw new Error(b.description || b.message || 'Sorry, this plate couldn\u2019t be added to your basket.');
        });
      });
    }

    function plural(sec) { return sec.key === 'ni' ? 'NI plates' : String(sec.title).toLowerCase(); }

    function renderSection(sec) {
      var wrap = el('section', 'wlc-ps__sec');
      wrap.setAttribute('aria-label', sec.title + ' matching your search');
      var head = el('div', 'wlc-ps__sec-head');
      head.appendChild(el('h2', null, sec.title + ' matching your search'));
      head.appendChild(el('span', 'wlc-ps__count',
        sec.total.toLocaleString('en-GB') + (sec.total_capped ? '+' : '') + ' found'));
      wrap.appendChild(head);

      if (!sec.items.length) {
        var empty = el('div', 'wlc-ps__empty');
        empty.appendChild(el('p', null, 'No ' + plural(sec) + ' match “' + label + '” right now.'));
        var p = el('p', null, (advKey ? 'Try leaving a box blank' : 'Try fewer letters') + (tel ? ', or call us on ' : '.'));
        if (tel) {
          var call = el('a', null, phone);
          call.href = 'tel:' + tel;
          p.appendChild(call);
          p.appendChild(document.createTextNode(' and we’ll help you find a plate.'));
        }
        empty.appendChild(p);
        wrap.appendChild(empty);
        return wrap;
      }

      var list = el('ul', 'wlc-ps__rows');
      sec.items.forEach(function (it) { list.appendChild(row(it)); });
      wrap.appendChild(list);

      var more = el('div', 'wlc-ps__more');
      var shown = sec.items.length;
      function footer(state) {
        more.textContent = '';
        if (state.more) {
          var b = el('button', 'wlc-ps__btn', 'View more ' + sec.title);
          b.type = 'button';
          b.addEventListener('click', function () {
            b.disabled = true;
            b.textContent = 'Loading…';
            getJSON(query({ section: sec.key, offset: shown })).then(function (res) {
              var s = res.status === 200 && res.body.sections && res.body.sections[0];
              if (!s) {
                footer(state);
                var why = res.status === 429 ? 'Too many searches. Please wait a minute and try again.'
                  : 'Sorry, more plates couldn’t be loaded. Please try again.';
                more.appendChild(el('p', null, why));
                return;
              }
              s.items.forEach(function (it) { list.appendChild(row(it)); });
              shown += s.items.length;
              footer(s);
            });
          });
          more.appendChild(b);
        } else if (state.refine) {
          more.appendChild(el('p', null, 'Refine your search to see more.'));
        }
        more.hidden = !more.firstChild;
      }
      footer(sec);
      wrap.appendChild(more);
      return wrap;
    }

    status.textContent = 'Searching…';
    getJSON(query()).then(function (res) {
      status.textContent = '';
      if (res.status === 200 && res.body.sections) {
        out.textContent = '';
        buyOn = !!res.body.buy;
        if (advKey) {
          label = String(res.body.query || '');
          title.textContent = 'Results for “' + label + '”';
          document.title = 'Results for ' + label + ' – ' + document.title;
        }
        res.body.sections.forEach(function (sec) { out.appendChild(renderSection(sec)); });
      } else if (res.status === 400 || res.status === 429 || (advKey && res.body.error === 'preparing')) {
        message(res.body.message || 'Please check your search and try again.');
      } else {
        unavailable();
      }
    });
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-wlc-results]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);     // theme editor
})();
